import React, { useEffect } from 'react';
import { connect } from "react-redux";
import { Switch, Route, Router } from 'react-router-dom';
import history from './utils/history';
import PrivateRoute from './utils/PrivateRoute';

import AppNavbar from './common/navbar/AppNavbar'

import CategoriesPage from './categories/components/CategoriesPage';
import ProductsPage from './products/components/ProductsPage';
// import SignInPage from './components/auth/signInPage';
// import ScannerPage from './components/qr_scanner/scannerPage';
// import LogoutPage from './components/auth/logoutPage';
import Page404 from './common/errors/404';
// import PreorderPage from './components/preorder/PreorderPage';
import FeedbackPage from './feedback/components/FeedbackPage';
import SearchPage from './search/components/SearchPage';
import AboutUsPage from './aboutus/components/AboutUsPage';
import AboutRestaurantPage from './aboutus/components/AboutRestaurantPage';
import AllProductsPage from './products/components/AllProductsPage';
import SubcatsWithProductsPage from './products/components/SubcatsWithProductsPage';
import SubcatsWithProductsSluggedPage from './products/components/SubcatsWithProductsSluggedPage';
import NavigateToComponent from './common/NavigateToComponent';
import ScanPage from './qr-scan/components/scanPage';
import VerifyTokenPage from './qr-scan/components/VerifyTokenPage';
import CategoriesHierarchyPage from './categories/components/CategoriesHierarchyPage';
import ViewProductPage from './products/components/ViewProductPage';
import LoginPage from './users/components/LoginPage';
import Auth from './utils/AuthC';
import OrdersPage from './orders/components/OrdersPage'
import ProfilePage from './profile/components/ProfilePage'


const MyRouter = (props) => {
    
    //     useEffect(() => {
    // if(!props.fetched) {
    //     props.fetchRules();
    // }
    //     }, []); // passing an empty array as second argument triggers the callback in useEffect only after the initial render thus replicating `componentDidMount` lifecycle behaviour

    // mainPage = <Route exact path='/:catSlug' component={CategoriesHierarchyPage} />
    // additionalBeginRoute = <Route exact path='/' component={CategoriesHierarchyPage} />

    return (
        <div>
            <Router history={history}>
                <div>
                    {/* {console.log(Auth.getToken())} */}
                    {props.isAuthenticated ? 
                        <AppNavbar />                    
                     :
                        null    
                    }
                    <Switch>
                        {/* <Route exact path='/product/:product_id' component={ViewProductPage} /> */}
                        <Route exact path='/login' component={LoginPage} />

                        <PrivateRoute exact path='/products/:subcat_id' component={ProductsPage} />
                        <PrivateRoute exact path='/feedback' component={FeedbackPage} />
                        <PrivateRoute exact path='/orders' component={OrdersPage} />
                        <PrivateRoute exact path='/profile' component={ProfilePage} />
                        
                        <PrivateRoute exact path='/search' component={SearchPage} />
                        <PrivateRoute exact path='/about-tabl' component={AboutUsPage} />
                        <PrivateRoute exact path='/about' component={AboutRestaurantPage} />
                        <PrivateRoute exact path='/subcategories/:subcat_id/products' component={NavigateToComponent} />
                        <PrivateRoute exact path='/scan' component={ScanPage} />
                        <PrivateRoute exact path='/t/:token' component={VerifyTokenPage} />

                        <PrivateRoute exact path='/:catSlug' component={CategoriesHierarchyPage} />
                        <PrivateRoute exact path='/' component={CategoriesHierarchyPage} />
                            
                        
                        <Route component={Page404} />

                        {/* <Route exact path='/signin' component={SignInPage} />
                        <Route exact path='/categories/:cat_id' component={ProductsListPage} />
                        <Route exact path='/scanTable' component={ScannerPage} />
                        <Route exact path='/preorder' component={PreorderPage} />
                        <Route exact path='/logout' component={LogoutPage} /> */}
                        {/* <Route path="*" exact={true} component={Page404} /> */}
                    </Switch>
                </div>

            </Router>
        </div>
    )
}

// export default MyRouter;


const mapStateToProops = (state, ownProps) => {
    return {
        settings: state.settings.settings || [],
        isAuthenticated: state.users.isAuthenticated || false
    };
};

export default (connect(mapStateToProops, {})(MyRouter));